import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PaymentMethodsService } from '../services/payment-methods.service';

export const initiatePaymentMethodSetupResolver: ResolveFn<any> = () => {
  const paymentMethodsService = inject(PaymentMethodsService);
  return paymentMethodsService.initiateSetup();
};
